module.exports = __webpack_public_path__ + "img/colony.6d3d9c3d.svg";